import styled from "styled-components";

export const PageBg = styled.div`
  background: transparent linear-gradient(13deg, #ffffff 0%, #f7f2ee 100%) 0% 0%
    no-repeat padding-box;
  font-family: "Poppins";
`;
